const gift = {
    isOpen: is_open_gift,
    thresholdPrice: $('#gift_thresholdPrice').text(),
    giftId: $('#gift_variant').text(),
    count: 1
}
gift.init = function () {
     
    if (!this.isOpen || this.thresholdPrice <= 0) {
        return false
    }

    this.checkGiftIsInCart().then(res => {
        this.checkCart(res)
    })
}

gift.checkGiftIsInCart = function () {
    return new Promise(resolve => {
        $.ajax({
            type: 'GET',
            url: `/cart.js`,
            dataType: "json",
            success: function (data) {
                // console.log('data', data);
                resolve(data)
            },
            error: function (XMLHttpRequest, textStatus) {
                console.log(XMLHttpRequest.responseJSON.description);
            }
        });
    })
}

gift.checkCart = function (data) {
    return new Promise(resolve => {
        let isInCart = false
        let total_price = data.total_price
        for (let i = 0; i < data.items.length; i++) {
            const item_id = data.items[i].variant_id;
            if (item_id == this.giftId) {
                isInCart = true;
                this.count = data.items[i].quantity;
                total_price -= data.items[i].final_price
            }
        }
        if (total_price / 100 >= this.thresholdPrice) {
            // console.log('达到赠送标准');
            if (!isInCart) {
                // console.log('不在购物车中，需要添加');
                this.addToCart(this.giftId).then(data => {
                    // console.log('赠品加入购物车成功');
                    this.onCartUpdate()
                })
            } else {
                // console.log('已在购物车中，不需要再添加');
            }
        } else {
            // console.log('未达到赠送标准');
            isInCart  && this.removeToCart(this.giftId).then(res => {
                this.onCartUpdate()
            })
        }
        resolve()
    });
}

gift.addToCart = function (variantId) {
    return new Promise(resolve => {
        $.ajax({
            type: 'post',
            url: `/cart/add?id=${variantId}`,
            dataType: "json",
            success: function (data) {
                // console.log('~~~~~~执行完毕')
                resolve()
            },
            error: function (XMLHttpRequest, textStatus) {
            //     $("body").append(`
            //   <div id="sp_notices_wrapper">
            //     <p class="shopify-info sp_notice show_notice">
            //       <i class="facl facl-attention"></i>
            //       Error: ${XMLHttpRequest.responseJSON.description}
            //       <i class="pegk pe-7s-close gift"></i>
            //     </p>  
            //   </div>`)
            //     $('.add_js_cart').removeClass('loading')
                console.log(XMLHttpRequest.responseJSON.description);
            }
        });
    })
}

gift.removeToCart = function (variantId) {
    return new Promise(resolve => {
        $.ajax({
            type: 'post',
            url: `/cart/change?id=${variantId}&quantity=${this.count - 1}`,
            dataType: "json",
            success: function (data) {
                // console.log('~~~~~~删除完毕')
                resolve()
            },
            error: function (XMLHttpRequest, textStatus) {
            //     $("body").append(`
            //   <div id="sp_notices_wrapper">
            //     <p class="shopify-info sp_notice show_notice">
            //       <i class="facl facl-attention"></i>
            //       Error: ${XMLHttpRequest.responseJSON.description}
            //       <i class="pegk pe-7s-close gift"></i>
            //     </p>  
            //   </div>`)
            //     $('.add_js_cart').removeClass('loading')
                console.log(XMLHttpRequest.responseJSON.description);
            }
        });
    })
}

gift.onCartUpdate = function (bl, blUp_items, id) {
    setTimeout(function () {
        T4SThemeSP.Cart.init()
    }, 300)
}

gift.init()